// modules
import React from 'react';
import ReactDom from 'react-dom';
import { HashRouter, Route } from 'react-router-dom';
import { StaticRouter } from 'react-router';
import ReactDOMServer from 'react-dom/server';

// aliased
import config from 'config';

// file
import HomeView from 'views/HomeView';

// side-effects
import './global.pcss';

// config
const HTML_ROOT_ID = '__main__';

// TODO: Only do this in dev + find a way to move into bundler
if (config.browser && module && module.hot) {
  // Accept hot module swaps
  module.hot.accept();
  
  // Reload stylesheets
  // todo: clean this up
  document.querySelectorAll('link[href][rel=stylesheet]').forEach((link) => {
    const nextStyleHref = /[?]/.test(link.href)
      ? `${ link.href }&${ Date.now() }`
      : link.href.replace(/(\?\d+)?$/, `?${ Date.now() }`);
    link.href = nextStyleHref;
  });
}

if (config.browser) {
  // Where the react dom is being injected
  const rootElement = document.getElementById(HTML_ROOT_ID);
  
  // Render a redux <Provider /> with react-router routes as children
  ReactDom.render((
    <HashRouter hashType={ 'noslash' }>
      <Route component={ HomeView } />
    </HashRouter>
  ), rootElement);
}

// render to a string for pre/static rendering
export const toString = (route, state) => {
  const ctx = {};
  const element = (
    <StaticRouter location={ route } context={ ctx }>
      <Route component={ HomeView } />
    </StaticRouter>
  );
  
  const html = ReactDOMServer.renderToString(element);
  
  return { html, state, redirect: ctx.url };
};



// WEBPACK FOOTER //
// ./src/index.jsx